import { useLocation } from "../components/Router/state";
import { matchPath } from "../components/Router/utils";
import { MaxBreakPoints } from "../style/constants";
import { useWindowSize } from "./useWindowSize";

export type LayoutConfig = {
  topBar: {
    hideRoutes: string[];
  };
  sidebar: {
    hideRoutes: string[];
    mobileHideRoutes: string[];
  };
  overlays: {
    hideRoutes: string[];
  };
  skeleton: {
    hideRoutes: string[];
  };
};

type UseLayoutConfigResponse = {
  topbar: boolean;
  sidebar: boolean;
  mobileSidebar: boolean;
  overlays: boolean;
  skeleton: boolean;
};

export const useLayoutConfig = (
  layoutConfig: LayoutConfig
): UseLayoutConfigResponse => {
  const { width } = useWindowSize();
  const location = useLocation();

  const isMobileView = width <= MaxBreakPoints.MEDIUM;

  const isTopBarHidden = layoutConfig.topBar.hideRoutes.some((route) =>
    matchPath(route, location.pathname)
  );

  const isSidebarHidden = layoutConfig.sidebar.hideRoutes.some((route) =>
    matchPath(route, location.pathname)
  );

  const isMobileSidebarHidden = layoutConfig.sidebar.mobileHideRoutes.some(
    (route) => matchPath(route, location.pathname)
  );

  const isOverlayHidden = layoutConfig.overlays.hideRoutes.some((route) =>
    matchPath(route, location.pathname)
  );

  const isSkeletonHidden = layoutConfig.skeleton.hideRoutes.some((route) =>
    matchPath(route, location.pathname)
  );

  return {
    topbar: !isTopBarHidden,
    sidebar: !isMobileView && !isSidebarHidden,
    mobileSidebar: isMobileView && !isMobileSidebarHidden,
    overlays: !isOverlayHidden,
    skeleton: !isSkeletonHidden,
  };
};
